
import {initWebComponent} from "@/helpers/web-component-helper";
import {getAnnouncements} from "@/http/services/http-services-announcement";

export class BookmarkNotificationComponent extends HTMLElement {
    constructor(){
        super();

        getAnnouncements().then( result => {
            const announcements = result.announcement
            const template = document.createElement('template');
            let innerHTML = `
            
          <div class="card m-3 bg-lighter" style="border-radius: 10px;">
             <div class="card-header font-weight-bold p-2">
                 <h2>
                     <span class="fa fa-bell navbar-icon" style="font-size:15px"></span>
                     Mededelingen
                     <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                        <span class="fa fa-times"></span>
                     </button>
                 </h2>
             </div>
            <div class="card-body p-2">
                  <div class="bg-danger text-white text-center font-weight-bold p-3" style="border-radius: 10px 10px 0 0">
                    ` + announcements.length + ` nieuwe mededelingen
                  </div>
                  <div class="list-group list-group-flush" style="border-radius: 0 0 10px 10px;">`

            announcements.map( announcement => {

                let url = ''
                if(announcement.Url){
                    url = `href="${announcement.Url}" target="_blank"`
                }

                innerHTML += `      
                    <a ${url} class="list-group-item bg-white list-group-item-action media d-flex align-items-center"> 
                      <div class="media-body line-height-condenced"> 
                        <div class="text-body" data-test="notification_title"> ` + announcement.Title + `</div> 
                        <div class="text-light small mt-1" data-test="notification_message"> 
                        ` + announcement.Message + `
                        </div> 
                        <div class="text-light small mt-1">
                            <i class="fa fa-clock"></i> ` +  announcement.UpdatedAtDutch + `</div> 
                      </div> 
                    </a>`
            })

            innerHTML += `
                  </div>
                </div>
            </div>
        `;
            template.innerHTML = innerHTML
            initWebComponent(this, template)

        })
    }
}

